module.exports = __webpack_public_path__ + "static/img/404.062137a9.png";